import axios from "axios"

export default class HttpService {

    static getHashedClientIdCustomerId(customerId, clientId) {
        return axios({
            method: 'get',
            url: '/api/customer/gethashedid',
            params: {customerId: customerId, clientId: clientId},
        })
    }

    static searchCustomer(keywords, clientId) {
        return axios({
            method: 'get',
            url: '/api/customer/nameornumber',
            params: {keywords: keywords, clientId: clientId},
        })
    }

    static createPushMessage(clientId, customerId, messageData) {
        return axios({
            method: 'post',
            url: '/api/chat/createMessage',
            params: {customerId: customerId, clientId: clientId, messageData: messageData},
        })
    }

    static getCustomerLanguage(customerId, clientId) {
        return axios({
            method: 'get',
            url: '/api/customer/language',
            params: {customerId: customerId, clientId: clientId},
        })
    }
}
